// extracted by mini-css-extract-plugin
module.exports = {"root":"root-3SLJ0zVbXs","centered":"centered-1fckgl3VF5"};